import { buildCloudinaryImageUrl } from './cloudinary';

/** Cloudinary uploads (databiqs-assets) — keyed by former local asset names. */
const TEAM_IMAGE_ASSETS = {
  ceo: { version: 'v1779487427', publicId: 'founder_ceo_yleptg', format: 'png' },
  cto: { version: 'v1779297637', publicId: 'CTO_np65yp', format: 'png' },
  amariFields: { version: 'v1779297637', publicId: 'Amari-Fields_dwoir6', format: 'png' },
  teamLead: { version: 'v1779297646', publicId: 'team-lead_wd0hry', format: 'png' },
  akhlaq: { version: 'v1779297636', publicId: 'Akhlaq_1_rvm9us', format: 'png' },
  alishba: { version: 'v1779297637', publicId: 'Alishba1_wokthp', format: 'png' },
  shamaim: { version: 'v1779297644', publicId: 'Shamaim_1_nwizxs', format: 'png' },
  businessDev: {
    version: 'v1779297637',
    publicId: 'business-development-executive_ipffau',
    format: 'jpg',
  },
  marketingManager: {
    version: 'v1779297642',
    publicId: 'marketing-manager_fagwhj',
    format: 'png',
  },
  projectManager: {
    version: 'v1779297643',
    publicId: 'project-manager_AI-Developer_iebpel',
    format: 'png',
  },
  irum: { version: 'v1779297640', publicId: 'Irum_1_a08uaj', format: 'png' },
  softwareEngineer3: {
    version: 'v1779297645',
    publicId: 'software-engineer3_ndy0uz',
    format: 'jpg',
  },
  softwareEngineer2: {
    version: 'v1779297645',
    publicId: 'software-engineer2_wo3v7c',
    format: 'png',
  },
  uiUxDesigner: { version: 'v1779297647', publicId: 'ui-ux-designer_c9ra1c', format: 'png' },
  softwareEngineer: {
    version: 'v1779297644',
    publicId: 'software-engineer_ew8som',
    format: 'png',
  },
  junaid: { version: 'v1779297641', publicId: 'junaid_qhvhxe', format: 'png' },
  fullstackAi: {
    version: 'v1779297638',
    publicId: 'fullstack-AI-Engineer_xh4k7a',
    format: 'png',
  },
  hamadKhan: { version: 'v1779297640', publicId: 'hamad_khan_dxym6b', format: 'png' },
  fatima: { version: 'v1779297638', publicId: 'fatima_tuz_zahra_pfhlhs', format: 'png' },
  laiba: { version: 'v1779297642', publicId: 'LAIBA_r12jkp', format: 'png' },
  hadeedTarar: { version: 'v1779297639', publicId: 'Hadeed_Tarar_hmhuzi', format: 'png' },
};

/** @param {keyof typeof TEAM_IMAGE_ASSETS} key @param {'team' | 'teamSpotlight' | 'ceoPortrait'} [preset] */
export function cloudinaryTeamImage(key, preset = 'team') {
  if (key === 'ceo') return CEO_IMAGE_URL;
  const asset = TEAM_IMAGE_ASSETS[key];
  if (!asset) {
    throw new Error(`Unknown Cloudinary team image key: ${key}`);
  }
  return buildCloudinaryImageUrl(asset, preset);
}

/** Founder/CEO portrait — About Us, team spotlight, Book a Consultation, CMS default. */
export const CEO_IMAGE_URL =
  'https://res.cloudinary.com/deelyxcjk/image/upload/v1779487427/founder_ceo_yleptg.png';

export const CEO_PORTRAIT_URL = CEO_IMAGE_URL;
